"use client"
import useStatusStore from "@/models/status";
import { useEffect, useState } from "react";

export const useStatus = ({ docid, media_id }: { docid?: string, media_id?: string }) => {
    const { likedDocList, followedUserList, setLikedDocList, setFollowedUserList } = useStatusStore();
    const [liked, setLiked] = useState(false);
    const [followed, setFollowed] = useState(false);
    const checkLiked = (docid: string) => {
        return likedDocList.includes(docid);
    }
    const checkFollowed = (userId: string) => {
        return followedUserList.includes(userId);
    }
    const toggleLiked = (docid: string) => {
        if (checkLiked(docid)) {
            setLikedDocList(likedDocList.filter((id) => id !== docid));
        } else {
            setLikedDocList([...likedDocList, docid]);
        }
    }
    const toggleFollowed = (userId: string) => {
        if (checkFollowed(userId)) {
            setFollowedUserList(followedUserList.filter((id) => id !== userId));
        } else {
            setFollowedUserList([...followedUserList, userId]);
        }
    }
    useEffect(() => {
        if (docid) {
            setLiked(checkLiked(docid));
        }
    }, [docid, likedDocList]);
    useEffect(() => {
        if (media_id) {
            setFollowed(checkFollowed(media_id));
        }
    }, [media_id, followedUserList]);
    return {
        toggleLiked,
        toggleFollowed,
        liked,
        followed,
        checkLiked,
        checkFollowed,
    };
}